import { render, staticRenderFns } from "./AuthForm.vue?vue&type=template&id=173e1f26&scoped=true"
import script from "./AuthForm.vue?vue&type=script&lang=js"
export * from "./AuthForm.vue?vue&type=script&lang=js"
import style0 from "./AuthForm.vue?vue&type=style&index=0&id=173e1f26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173e1f26",
  null
  
)

export default component.exports